<template>
  <v-container>
    <v-row>
      <div class="select">{{ nomOperari }}</div>
    </v-row>
    <v-row align="center">
      <v-chip v-if="error == false && !temporaryErrorMessage" class="mr-2">{{ displayEstat }}</v-chip>
      <v-chip v-else color="red" class="mr-2">{{ displayEstat }}</v-chip>
      <v-btn v-if="ordre && (principal || permisImputarMaterial || mode == 'N')" @click="entrarMaterial()" rounded
        color="blue" style="color: white">{{ $t("OpcionsOrdre") }}</v-btn>
    </v-row>

    <v-row justify="center">
      <span class="clock">{{ time }}</span>
    </v-row>

    <v-row xs12 v-if="mode != 'N'">
      <v-select class="select" v-model="tipusFitxada" :items="tipus" item-value="id" item-text="nom" return-object
        @change="onChangeTipus($event)"></v-select>
    </v-row>

    <v-row>
      <v-btn height="90px" block large @click="iniciar()" color="green">
        {{ $t("Iniciar") }}
        <v-icon right dark>mdi-arrow-right-thick</v-icon>
      </v-btn>
    </v-row>
    <v-row class="mt-6">
      <v-btn height="90px" block large @click="finalitzar()" color="red" :disabled="desactivarFi">
        {{ $t("Finalitzar") }}
        <v-icon right dark>mdi-arrow-left-thick</v-icon>
      </v-btn>
    </v-row>
  </v-container>
</template>

<script>
import api from "../api.js";
import { getCurrentPositionSafe } from "../utils/geolocation.js";

export default {
  created() {
    api.get("/api/v1/mode").then((response) => {
      this.mode = response.data;
      localStorage.setItem("systimes.mode" + api.getEmp(), this.mode);
    });

    // Only validate token if we're not already authenticated
    // App.vue handles initial token validation
    if (!this.$store.state.auth) {
      this.validateToken();
    }

    this.loadData();
    this.tipusFitxada = 0;
    this.desactivarFi = false;
    if (localStorage.getItem("systimes.idioma" + api.getEmp()) == "Català") {
      this.$i18n.locale = "ca";
    } else {
      this.$i18n.locale = "es";
    }
  },
  mounted() {
    this.ordre = localStorage.getItem("systimes.ordre" + api.getEmp());
    if (this.ordre != null) {
      this.ordre = JSON.parse(this.ordre);
      this.principal = this.ordre?.principal == "S";
    }

    if (localStorage.getItem("systimes.inici" + api.getEmp()) == "1") {
      localStorage.setItem("systimes.inici" + api.getEmp(), "0");
      this.iniciar();
    }

    api.get("/api/v1/permisImputarMaterial").then((response) => {
      this.permisImputarMaterial = (response.data == "S");
    });

    // Check for stored error messages from other views
    this.checkForStoredErrorMessage();
  },
  beforeDestroy() {
    // Clean up the timeout when the component is destroyed
    if (this.temporaryErrorTimeout) {
      clearTimeout(this.temporaryErrorTimeout);
    }
  },
  data: () => ({
    error: false,
    version: localStorage.getItem("systimes.version"),
    nomOperari: localStorage.getItem("systimes.nomOperari" + api.getEmp()),
    tipusFitxada: 0,
    estat: localStorage.getItem("systimes.estat" + api.getEmp()),
    time: "--:--",
    seconds: "",
    tipus: [],
    ultMilis: new Date().getTime(),
    desactivarFi: false,
    mode: "",
    ordre: null,
    principal: false,
    permisImputarMaterial: false,
    // New properties for persistent error messages
    temporaryErrorMessage: null,
    temporaryErrorTimeout: null,
  }),
  computed: {
    displayEstat() {
      // Show temporary error message if it exists, otherwise show normal estat
      return this.temporaryErrorMessage || this.estat;
    }
  },
  methods: {
    // Method to show temporary error messages that persist for a specified duration
    showTemporaryError(message, duration = 10000) {
      // Clear any existing timeout
      if (this.temporaryErrorTimeout) {
        clearTimeout(this.temporaryErrorTimeout);
      }

      // Set the temporary error message
      this.temporaryErrorMessage = message;
      this.error = true;

      // Clear the temporary error after the specified duration
      this.temporaryErrorTimeout = setTimeout(() => {
        this.temporaryErrorMessage = null;
        this.error = false;
        this.temporaryErrorTimeout = null;
      }, duration);
    },

    // Validate token with proper error handling to distinguish between connection issues and invalid tokens
    async validateToken() {
      const token = localStorage.getItem("systimes.token" + api.getEmp());

      // If no token is stored, go directly to token screen
      if (!token) {
        this.$router.push("/Token");
        return;
      }

      try {
        const result = await api.validateToken(token);

        if (result.isValid) {
          // Token is valid - continue normally
          return;
        }

        if (result.isConnectionError) {
          // Connection error - show error message but don't redirect
          let errorMessage;
          if (localStorage.getItem("systimes.idioma" + api.getEmp()) == "Català") {
            if (!result.error.response) {
              errorMessage = "Error de connexió. Comproveu la connexió a internet.";
            } else {
              errorMessage = "Error del servidor. Intenteu-ho més tard.";
            }
          } else {
            if (!result.error.response) {
              errorMessage = "Error de conexión. Compruebe la conexión a internet.";
            } else {
              errorMessage = "Error del servidor. Inténtelo más tarde.";
            }
          }
          this.showTemporaryError(errorMessage, 8000);
        } else {
          // Token is invalid - redirect to token screen
          this.$router.push("/Token");
        }
      } catch (error) {
        // Unexpected error
        console.error("Unexpected error in token validation:", error);
        let errorMessage;
        if (localStorage.getItem("systimes.idioma" + api.getEmp()) == "Català") {
          errorMessage = "Error inesperat validant el token.";
        } else {
          errorMessage = "Error inesperado validando el token.";
        }
        this.showTemporaryError(errorMessage, 8000);
      }
    },
    entrarMaterial() {
      var or = localStorage.getItem("systimes.ordre" + api.getEmp());
      if (or != null && or != "") {
        this.$store.commit("setBack", "/");
        if (localStorage.getItem("systimes.mode" + api.getEmp()) == "N") {
          this.$router.push("Material");
        } else {
          this.$router.push("MaterialG");
        }
      }
    },
    eventEntrada(lat, lng, ordre) {
      console.log("Entrada...");
      this.error = false;
      api
        .post("/api/v1/event", {
          id: Number(localStorage.getItem("systimes.idOperari" + api.getEmp())),
          tipus: "I",
          tipusFitxada: this.tipusFitxada.id,
          lat: lat,
          lng: lng,
          ordre: ordre,
        })
        .then(() => {
          if (this.tipusFitxada == 0) {
            this.estat = "Entrada " + this.time;
          } else {
            console.log(this.tipusFitxada);
            this.estat = this.tipusFitxada.nom + " " + this.time;
            this.tipusFitxada = 0;
            this.desactivarFi = false;
          }

          localStorage.setItem("systimes.estat" + api.getEmp(), this.estat);
        })
        .catch((err) => {
          console.log(err);
          this.tipusFitxada = 0;
          this.desactivarFi = false;

          let errorMessage;
          if (err.response && err.response.status == 401) {
            if (localStorage.getItem("systimes.idioma" + api.getEmp()) == "Català") {
              errorMessage = "Usuari no autoritzat";
            } else {
              errorMessage = "Usuario no autorizado";
            }
          } else if (err.response && err.response.status == 409) {
            // Error específic: entrada/sortida duplicada per marge de temps
            if (localStorage.getItem("systimes.idioma" + api.getEmp()) == "Català") {
              errorMessage = "Entrada no registrada: ja hi ha una entrada recent a les " + err.response.data;
            } else {
              errorMessage = "Entrada no registrada: ya hay una entrada reciente a las " + err.response.data;
            }
          } else {
            if (localStorage.getItem("systimes.idioma" + api.getEmp()) == "Català") {
              errorMessage = "Error connectant amb el servidor";
            } else {
              errorMessage = "Error conectando con el servidor";
            }
          }

          // Show temporary error message for 15 seconds for 409 errors, 8 seconds for others
          const duration = (err.response && err.response.status == 409) ? 5000 : 5000;
          this.showTemporaryError(errorMessage, duration);
        });
    },

    // Check for error messages stored by other views
    checkForStoredErrorMessage() {
      const errorMessage = localStorage.getItem("systimes.errorMessage" + api.getEmp());
      const errorTimestamp = localStorage.getItem("systimes.errorTimestamp" + api.getEmp());

      if (errorMessage && errorTimestamp) {
        const now = Date.now();
        const timestamp = parseInt(errorTimestamp);

        // Only show the error if it's recent (within 30 seconds)
        if (now - timestamp < 30000) {
          // Show for 15 seconds if it contains "recent" (indicating 409 error), 8 seconds otherwise
          const duration = errorMessage.includes("recent") || errorMessage.includes("reciente") ? 15000 : 8000;
          this.showTemporaryError(errorMessage, duration);
        }

        // Clear the stored error message
        localStorage.removeItem("systimes.errorMessage" + api.getEmp());
        localStorage.removeItem("systimes.errorTimestamp" + api.getEmp());
      }
    },
    eventSortida(lat, lng, ordre) {
      console.log("Sortida...");
      this.error = false;
      api
        .post("/api/v1/event", {
          id: Number(localStorage.getItem("systimes.idOperari" + api.getEmp())),
          tipus: "F",
          tipusFitxada: this.tipusFitxada.id,
          lat: lat,
          lng: lng,
          ordre: ordre,
        })
        .then(() => {
          if (localStorage.getItem("systimes.idioma" + api.getEmp()) == "Català") {
            this.estat = "Sortida " + this.time;
          } else {
            this.estat = "Salida " + this.time;
          }

          localStorage.setItem("systimes.estat" + api.getEmp(), this.estat);
          this.tipusFitxada = 0;
          this.desactivarFi = false;
        })
        .catch((err) => {
          console.log(err);
          this.tipusFitxada = 0;
          this.desactivarFi = false;

          let errorMessage;
          if (err.response && err.response.status == 401) {
            if (localStorage.getItem("systimes.idioma" + api.getEmp()) == "Català") {
              errorMessage = "Usuari no autoritzat";
            } else {
              errorMessage = "Usuario no autorizado";
            }
          } else if (err.response && err.response.status == 409) {
            // Error específic: entrada/sortida duplicada per marge de temps
            if (localStorage.getItem("systimes.idioma" + api.getEmp()) == "Català") {
              errorMessage = "Sortida no registrada: ja hi ha una sortida recent a les " + err.response.data;
            } else {
              errorMessage = "Salida no registrada: ya hay una salida reciente a las " + err.response.data;
            }
          } else {
            if (localStorage.getItem("systimes.idioma" + api.getEmp()) == "Català") {
              errorMessage = "Error connectant amb el servidor";
            } else {
              errorMessage = "Error conectando con el servidor";
            }
          }

          // Show temporary error message for 15 seconds for 409 errors, 8 seconds for others
          const duration = (err.response && err.response.status == 409) ? 5000 : 5000;
          this.showTemporaryError(errorMessage, duration);
        });
    },
    iniciar() {
      console.log("Iniciant...");
      if (localStorage.getItem("systimes.mode" + api.getEmp()) == "C") {
        this.iniciar1();
      } else {
        api
          .post("/api/v1/operari", {
            id: Number(localStorage.getItem("systimes.idOperari" + api.getEmp())),
          })
          .then((resp) => {
            if (resp.data.ordres == "S") {
              // TODO
              // axios
              //   .post(api.URL() + "/api/v1/hiHaOrdresPendents", {
              //     id: Number(localStorage.getItem("systimes.idOperari" + api.getEmp())),
              //   })
              //   .then((response) => {
              let nOrdres = 0;
              if (localStorage.getItem("systimes.ordre" + api.getEmp()) != null) {
                nOrdres = 1;
              }

              if (localStorage.getItem("systimes.mode" + api.getEmp()) == "N") {
                if (nOrdres > 0) {
                  localStorage.setItem("systimes.inici" + api.getEmp(), "1");
                  this.$router.push("/OrdresPendents");
                } else {
                  this.$router.push("/Ordres");
                }
              } else {
                if (nOrdres > 0) {
                  localStorage.setItem("systimes.inici" + api.getEmp(), "1");
                  this.$router.push("/OrdresPendentsG");
                } else {
                  localStorage.setItem(
                    "systimes.tipusFixada" + api.getEmp(),
                    this.tipusFitxada.toString()
                  );
                  this.$router.push("/OrdresG");
                }
              }
              // });
            } else {
              this.iniciar1();
            }
          })
          .catch(() => {
            this.iniciar1();
          });
      }
    },
    iniciar1() {
      console.log("Iniciant 1...");
      var milis = new Date().getTime();
      console.log(milis, this.ultMilis);
      if (milis - this.ultMilis > 1000) {
        console.log("Iniciant 1.1...");
        /*
        this.$getLocation()
          .then((coordinates) => {
            this.eventEntrada(coordinates.lat, coordinates.lng);
            console.log(coordinates);
          })
          .catch(() => {
            this.eventEntrada(0, 0, "");
          });
        */
        // Use robust geolocation with timeout and fallback
        getCurrentPositionSafe({ timeout: 4000 }).then((result) => {
          console.log("Geolocation result:", result);
          if (result.hasLocation) {
            console.log("Using accurate coordinates:", result.lat, result.lng);
          } else {
            console.log("Using fallback coordinates (0, 0). Error:", result.error);
          }
          this.eventEntrada(result.lat, result.lng);
        }).catch((error) => {
          // This should never happen with getCurrentPositionSafe, but just in case
          console.error("Unexpected geolocation error:", error);
          this.eventEntrada(0, 0, "");
        });
      }
      this.ultMilis = new Date().getTime();
    },

    finalitzar() {
      if (localStorage.getItem("systimes.mode" + api.getEmp()) == "C") {
        this.finalitzar1();
      } else {
        api
          .post("/api/v1/operari", {
            id: Number(localStorage.getItem("systimes.idOperari" + api.getEmp())),
          })
          .then((resp) => {
            if (resp.data.ordres == "S") {
              /*
              this.$getLocation();
                .then((coordinates) => {
                  this.finalitzar0(coordinates.lat, coordinates.lng);
                })
                .catch(() => {
                  this.finalitzar0(0.0, 0.0);
                });
              */
              // Use robust geolocation with timeout and fallback
              getCurrentPositionSafe({ timeout: 4000 }).then((result) => {
                console.log("Finalitzar geolocation result:", result);
                if (result.hasLocation) {
                  console.log("Using accurate coordinates for finalitzar:", result.lat, result.lng);
                } else {
                  console.log("Using fallback coordinates (0, 0) for finalitzar. Error:", result.error);
                }
                this.finalitzar0(result.lat, result.lng);
              }).catch((error) => {
                // This should never happen with getCurrentPositionSafe, but just in case
                console.error("Unexpected geolocation error in finalitzar:", error);
                this.finalitzar0(0.0, 0.0);
              });
            } else {
              this.finalitzar1();
            }
          })
          .catch((error) => {
            console.log(error);
            this.finalitzar1();
          });
      }
    },
    finalitzar0(lat, lng) {
      localStorage.setItem("systimes.lat" + api.getEmp(), lat);
      localStorage.setItem("systimes.lng" + api.getEmp(), lng);
      if (localStorage.getItem("systimes.mode" + api.getEmp()) == "N") {
        this.$router.push("/OrdresPendents");
      } else {
        this.$router.push("/OrdresPendentsG");
      }
      /*
      axios
        .post(api.URL() + "/api/v1/sortidaOrdre", {
          idOperari: Number(localStorage.getItem("systimes.idOperari" + api.getEmp())),
          nomOperari: localStorage.getItem("systimes.nomOperari" + api.getEmp()),
          lat: lat,
          lng: lng,
        })
        .then(() => {
          this.estat = "Sortida " + this.time;
          localStorage.setItem("systimes.estat" + api.getEmp(), this.estat);
        })
        .catch(() => {});
        */
    },
    finalitzar1() {
      var milis = new Date().getTime();
      if (milis - this.ultMilis > 1000) {
        /*
        this.$getLocation()
          .then((coordinates) => {
            this.eventSortida(coordinates.lat, coordinates.lng);
            console.log(coordinates);
          })
          .catch(() => {
            this.eventSortida(0, 0, "");
          });
        */
        // Use robust geolocation with timeout and fallback
        getCurrentPositionSafe({ timeout: 4000 }).then((result) => {
          console.log("Finalitzar1 geolocation result:", result);
          if (result.hasLocation) {
            console.log("Using accurate coordinates for event sortida:", result.lat, result.lng);
          } else {
            console.log("Using fallback coordinates (0, 0) for event sortida. Error:", result.error);
          }
          this.eventSortida(result.lat, result.lng, "");
        }).catch((error) => {
          // This should never happen with getCurrentPositionSafe, but just in case
          console.error("Unexpected geolocation error in finalitzar1:", error);
          this.eventSortida(0, 0, "");
        });
      }
      this.ultMilis = new Date().getTime();
    },
    getTime() {
      api.get("/api/v1/time").then((response) => {
        this.time = response.data;
        localStorage.setItem("systimes.time" + api.getEmp(), this.time);
      });
    },
    clock() {
      // Only update estat from localStorage if we don't have a temporary error message
      if (!this.temporaryErrorMessage) {
        this.estat = localStorage.getItem("systimes.estat" + api.getEmp());
      }

      var d = new Date();
      this.time =
        d.getHours().toString().padStart(2, "0") +
        ":" +
        d.getMinutes().toString().padStart(2, "0");
      this.seconds = d.getSeconds().toString().padStart(2, "0");
      localStorage.setItem("systimes.time" + api.getEmp(), this.time);
    },
    loadData() {
      api.get("/api/v1/tipus", { skipErrorDialog: true }).then((response) => {
        this.tipus = response.data;
      }).catch((error) => {
        // Silenciar errors de connexió per aquesta crida periòdica
        // No mostrar el diàleg d'error per evitar molèsties a l'usuari
        console.log("Error carregant tipus (silenciat):", error);
      });
    },
    onChangeTipus(event) {
      this.desactivarFi = !(event.id == 0);
    },
  },

  timers: {
    clock: {
      time: 1000,
      repeat: true,
      inmediate: true,
      autostart: true,
    },
    loadData: {
      time: 60000,
      repeat: true,
      inmediate: true,
      autostart: true,
    },
  },
};
</script>

<style>
.clock {
  font-size: 100px;
  font-weight: bold;
}

.select {
  font-size: 20px;
  font-weight: bold;
}

.version {
  font-size: 10px;
  font-weight: bold;
}
</style>
